import PropTypes from 'prop-types';
import React from 'react';
import { convertToRaw, Draft } from '@ublend-npm/th90-editor';
import Editor from '../EditorPlus/EditorPlus.container';
import style, { overflowHiddenClass } from './style';
import styleUtils from '@ublend-npm/aulaui-next-web/styles/utils';

import Dialog, { DialogTitle, DialogContent, DialogActions } from '../Dialog';

const ITEM_CLASS_MAP = {
  UBInboxMessage: 'message',
  UBComment: 'comment',
  UBClassRoomPost: 'post',
};

class EditContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      currentHeight: 0,
      hasContent: false,
      message: '',
    };

    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
  }

  handleRequestClose() {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }
  }

  handleHeightChange(newHeight) {
    this.setState({ currentHeight: newHeight });
  }

  async handleEdit() {
    const { updateContent } = this.props;
    this.setState({ saving: true, message: 'Saving the post.' });

    try {
      await updateContent(convertToRaw(this.editor.editor.getEditorState()));
      this.setState({ message: 'The post has been saved.' });
      setTimeout(() => {
        this.setState({ saving: false, message: '' });
        this.handleRequestClose();
      }, 1000);
    } catch (error) {
      this.setState({ message: 'The post has not been saved.' });
      console.log(error);
    }
  }

  handleEditorChange(editorState) {
    if (!this.editor) {
      return;
    }

    const { hasContent } = this.state;

    if (this.editor.isEmpty(editorState.getCurrentContent()) && hasContent) {
      this.setState({ hasContent: false });
    } else if (
      !this.editor.isEmpty(editorState.getCurrentContent()) &&
      !hasContent
    ) {
      this.setState({ hasContent: true });
    }
  }

  render() {
    const { content, open, itemClass } = this.props;
    const { currentHeight, saving, hasContent } = this.state;

    const initialContent = content ? JSON.parse(content) : null;
    if (
      initialContent &&
      initialContent.blocks[initialContent.blocks.length - 1].type ===
        'atomic' &&
      initialContent.blocks[initialContent.blocks.length - 1].data.type !==
        'spacing'
    ) {
      initialContent.blocks = [
        ...initialContent.blocks,
        {
          key: Draft.genKey(),
          text: '',
          type: 'atomic',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {
            type: 'spacing',
          },
        },
        {
          key: Draft.genKey(),
          text: '',
          type: 'unstyled',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ];
    }

    return (
      <Dialog
        id="edit-content-modal"
        open={open}
        onClose={this.handleRequestClose}
        maxWidth="md"
        classes={{
          root: overflowHiddenClass,
          paperScrollPaper: overflowHiddenClass,
        }}
      >
        <DialogTitle
          id="edit-content-modal-dialogtitle"
          onClose={this.handleRequestClose}
        >
          {`Edit ${ITEM_CLASS_MAP[itemClass]}`}
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              height: currentHeight,
              maxHeight: 'calc(100vh - 150px)',
            }}
          >
            <div style={style.editorWrapper}>
              {open ? (
                <Editor
                  wrappedRef={(r) => {
                    this.editor = r;
                  }}
                  autoFocus
                  type={ITEM_CLASS_MAP[itemClass]}
                  onChange={this.handleEditorChange}
                  maxEditorHeight="calc(100vh - 250px)"
                  onHeightChange={this.handleHeightChange}
                  disabled={saving}
                  noUpload
                  initialEditorState={initialContent}
                  pluginsConfigs={{
                    file: { superfocused: true },
                    textFormatter: {
                      inverted: true,
                    },
                  }}
                />
              ) : null}
            </div>
          </div>
        </DialogContent>
        <DialogActions
          primary={{
            label: 'Save',
            onClick: this.handleEdit,
            loading: saving,
            disabled: saving || !hasContent,
          }}
          secondary={{
            label: 'Cancel',
            onClick: this.handleRequestClose,
          }}
        />
        <div
          css={[styleUtils.visuallyHidden()]}
          aria-live="polite"
          role="status"
        >
          {this.state.message}
        </div>
      </Dialog>
    );
  }
}

EditContent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updateContent: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  itemClass: PropTypes.string.isRequired,
};

export default EditContent;
